export const DoneIconBig = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 5C16.225 5 5 16.225 5 30C5 43.775 16.225 55 30 55C43.775 55 55 43.775 55 30C55 16.225 43.775 5 30 5ZM41.95 24.25L27.775 38.425C27.425 38.775 26.95 38.975 26.45 38.975C25.95 38.975 25.475 38.775 25.125 38.425L18.05 31.35C17.325 30.625 17.325 29.425 18.05 28.7C18.775 27.975 19.975 27.975 20.7 28.7L26.45 34.45L39.3 21.6C40.025 20.875 41.225 20.875 41.95 21.6C42.675 22.325 42.675 23.5 41.95 24.25Z"
        fill="#1FC16B"
      />
    </svg>
  );
};
